export default import.meta.ROLLDOWN_FILE_URL_DqcIQZKA2wTrpIVzgpbBow